export default __webpack_public_path__ + "static/media/minimog-bg.768747ca.jpg";